import React, { useState, useEffect, useContext } from "react";
import swal from "sweetalert";
// material components
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import makeStyles from '@mui/styles/makeStyles';

import {
  Typography,
  TextField,
  Card,
  CardHeader,
  CardContent,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { ReactTabulator } from "react-tabulator";
import Autocomplete from '@mui/material/Autocomplete';

import {
  Link,
  AddToHomeScreen,
  Launch
 } from "@mui/icons-material";

// core components
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar.js";

import { useQuery } from "@tanstack/react-query";
import * as api from "../../actions/api";

import { useTranslation } from "react-i18next";
// Highcharts component
import Highcharts from "highcharts/highstock";
import "highcharts/modules/exporting.js";
import "highcharts/modules/accessibility.js";
import HighchartsReact from "highcharts-react-official";
import * as Service from "../../services/Service.js";

import Constants from "services/Constants.js";
import { UserContext } from "../../context/user-info-context";
import { getDefaultMonthYear, getARVFacilityList } from "../../services/Common";

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {checkLogin, checkUserPermission,getUserActionPermission} from "../../services/CheckUserAccess";
import encryptionService from "../../services/encryptionService";

// getCurrentMonthPatients
const useStyles = makeStyles({
  root: {
    // minWidth: 275,
    width: "20%",
    margin: "0 1rem",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  cardDiv: {
    display: "flex",
  }, 
  fullWidth: {
    width: "100%",
  },
});

const DashboardPage = (props) => {

  //get DispensingLanguage
const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage")
);

const lan = localStorage.getItem("LangCode");
const { t, i18n } = useTranslation();

const menukey = "patient-dashboard";
const YearList = JSON.parse(localStorage.getItem("YearList"));
const MonthList = JSON.parse(localStorage.getItem("MonthList"));
//const Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

/* let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Facility"])};
const FacilityList = [All_Facility_label].concat(getARVFacilityList());  */
//const FacilityList = [All_Facility_label].concat(Facility_List); 

const Age_Group = JSON.parse(localStorage.getItem("AgeGroup"));
let All_AgeGroup_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Age Group"])};
const AgeGroup = [All_AgeGroup_label].concat(Age_Group); 

/* const bFacilitySelected = localStorage.getItem("bFacilitySelected"); */
const FacilityId = localStorage.getItem("FacilityId");
const [toggleButtonValue, setToggleButton] = React.useState("1");
const [toggleButtonValuePaediatric, setToggleButtonPaediatric] = React.useState("1");
const [toggleButtonValueActiveQueue, setToggleButtonValueActiveQueue] = React.useState("1");

const [ columnsStockStatusTable, setColumnsStockStatusTable] = useState([]);
const [ stockStatusTableData, setStockStatusTableData] = useState([]);


            
/* =============Start Department, Zone, Commune, Facility Dipendency=============  */
const bFacilitySelected = localStorage.getItem("bFacilitySelected");
const UserInfo = encryptionService.decryptUserInfo();
const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;
const defaultZoneId = UserInfo == 0 ? 0 : UserInfo[0].ZoneId;
const defaultDistrictId = UserInfo == 0 ? 0 : UserInfo[0].DistrictId;

const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

const Regionlist = JSON.parse(localStorage.getItem("Regionlist"));
Regionlist.unshift(objAll);
const [currRegionId, setcurrRegionId] = useState(
  bFacilitySelected == 1 ? defaultRegionId : 0
);
const [chosenValuesRegion, setChosenValuesRegion] = useState(
  bFacilitySelected == 1
    ? (Regionlist.find((list) => list.id == defaultRegionId) ?? null)
    : objAll
);

let TempZSList = useState([]);
const [ZoneList, setZoneListLocal] = useState(TempZSList);
//const [currZoneId, setcurrZoneId] = useState(0);
const [currZoneId, setcurrZoneId] = useState(
  bFacilitySelected == 1 ? defaultZoneId : 0
);
const [chosenValuesZone, setChosenValuesZone] = useState({});

let TempCommuneList = useState([]);
const [CommuneList, setCommuneListLocal] = useState(TempCommuneList);
//const [currCommuneId, setcurrCommuneId] = useState(0);
const [currCommuneId, setcurrCommuneId] = useState(
  bFacilitySelected == 1 ? defaultDistrictId : 0
);
/* const [chosenValuesDistrict, setChosenValuesDistrict] = useState({
  "DistrictId": objAll
}); */

const [chosenValuesDistrict, setChosenValuesDistrict] = useState({});

let TempFacilityList = useState([]);
const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);
const [currFacilityId, setcurrFacilityId] = useState(
  bFacilitySelected == 1 ? FacilityId : 0
);
const [chosenValuesFacility, setChosenValuesFacility] = useState({});

React.useEffect(() => {
  cZoneList();
}, [currRegionId]);

React.useEffect(() => {
  cCommuneList();
}, [currRegionId, currZoneId]);

React.useEffect(() => {
  cFacilityList();
}, [currRegionId, currZoneId, currCommuneId]);

//====== Start Choosen Dropdown===========

const handleChangeChoosenRegion = (name, valueobj, value) => {
  /*  let chosenValuesDataRegion = { ...chosenValuesRegion};
chosenValuesDataRegion[name] = valueobj; */
  setChosenValuesRegion(valueobj);

  /* setFirstLoad(true); */
  //setLoading(false);
  setcurrRegionId(value);

  setcurrZoneId(0);
  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesZone(objAll);
  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenZone = (name, valueobj, value) => {
  /* let chosenValuesDataZone = { ...chosenValuesZone};
chosenValuesDataZone[name] = valueobj; */
  setChosenValuesZone(valueobj);

  /* setFirstLoad(true); */
  //setLoading(false);
  setcurrZoneId(value);

  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenDistrict = (name, valueobj, value) => {
  /* let chosenValuesDataDistrict = { ...chosenValuesDistrict};
chosenValuesDataDistrict[name] = valueobj; */
  setChosenValuesDistrict(valueobj);

  //setLoading(false);
  setcurrCommuneId(value);

  setcurrFacilityId(0);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  /*  let chosenValuesDataFacility = { ...chosenValuesFacility};
chosenValuesDataFacility[name] = valueobj; */
  setChosenValuesFacility(valueobj);

  //setLoading(false);
  setcurrFacilityId(value);
};

//====== End Choosen Dropdown===========

const cZoneList = () => {
  let ZoneListParam = {
    action: "Zonelist",
    RegionId: currRegionId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", ZoneListParam)
    .then((res) => {
      let All_Zone_label = objAll;
      const Zone_List = [All_Zone_label].concat(res.datalist);
      setZoneListLocal(Zone_List);

      let defaultZoneDDD =
        (Zone_List.find((list) => list.id == currZoneId) ?? null);
      /* let chosenValuesDataZoneAA = {};
      chosenValuesDataZoneAA["ZoneId"] = defaultZoneDDD; */
      setChosenValuesZone(defaultZoneDDD);
    })
    .catch((err) => {});
};

const cCommuneList = () => {
  let CommuneListParam = {
    action: "Communelist",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", CommuneListParam)
    .then((res) => {
      let All_Commune_label = objAll;
      const Commune_List = [All_Commune_label].concat(res.datalist);
      setCommuneListLocal(Commune_List);

      let defaultCommune =
        (Commune_List.find((list) => list.id == currCommuneId) ?? null);
      /* let chosenValuesDataCommune = {};
    chosenValuesDataCommune["DistrictId"] = defaultCommune; */
      setChosenValuesDistrict(defaultCommune);
    })
    .catch((err) => {});
};

const cFacilityList = () => {
  let FacilityListParam = {
    action: "ARVFacilityListByDepartmentZoneCommune",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    DistrictId: currCommuneId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", FacilityListParam)
    .then((res) => {
      let All_Facility_label = objAll;
      const Facility_List = [All_Facility_label].concat(res.datalist);
      setFacilityListLocal(Facility_List);
      let defaultFacilityDDD =
        (Facility_List.find(
            (facilitylist) => facilitylist.id == currFacilityId
          ) ?? null);

      /* let chosenValuesDataFacilityAA = {};
      chosenValuesDataFacilityAA["FacilityId"] = defaultFacilityDDD; */

      setChosenValuesFacility(defaultFacilityDDD);
    })
    .catch((err) => {});
};

/* =============End Department, Zone, Commune, Facility Dipendency=============  */
 

  const userCtx = useContext(UserContext);
  // const lan = userCtx.userInfo.LangId; //"fr_FR";


  // let currDate = new Date();
  // let defaultYear = currDate.getFullYear();
  // let defaultMonthId = currDate.getMonth();

  // //0=jan
  // if (defaultMonthId == 0) {
  //   defaultYear = defaultYear - 1;
  //   defaultMonthId = 12;
  // } else {
  //   defaultMonthId = defaultMonthId;
  // }

  const [currYearId, setCurrYearId] = useState(getDefaultMonthYear().defaultYear);
  const [chosenValuesYear, setChosenValuesYear] = useState(
    YearList.find((item) => item.id == getDefaultMonthYear().defaultYear) ?? null
  );
  const [currMonthId, setCurrMonthId] = useState(getDefaultMonthYear().defaultMonthId);
  const [chosenValuesMonth, setChosenValuesMonth] = useState(
    MonthList.find((item) => item.id == getDefaultMonthYear().defaultMonthId) ?? null
  );
  //const [currFacilityId, setCurrFacilityId] = useState(0);
/*   const [currFacilityId, setCurrFacilityId] = useState(bFacilitySelected == 1? FacilityId: 0); */
  const [currAgeGroupId, setCurrAgeGroupId] = useState(0);

  const Gender_List = JSON.parse(localStorage.getItem("Gender"));
  let All_Gender_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Gender"])};
  const GenderList = [All_Gender_label].concat(Gender_List); 
  const [currGenderTypeId, setCurrGenderTypeId] = useState(0);

  const [PatientCountData, setPatientCountDatat] = useState([]);
  const [ActivePatientTrendData, setActivePatientTrendData] = useState([]);
  const [AdultPatientsByProtocolData, setAdultPatientsByProtocolData] =   useState([]);
  const [ PaediatricPatientsByProtocolData, setPaediatricPatientsByProtocolData] = useState([]);


  const goToTrendOfActivePatients = () => {
    window.open(
      process.env.REACT_APP_BASE_NAME +`/trend-of-active-patients`
    );
  }

  const goToAdultPatientsByProtocol = () => {
    window.open(
      process.env.REACT_APP_BASE_NAME +`/adult-patients-by-protocol`
    );
  }

  const goToPreEPPatientsReport = () => {
    window.open(
      process.env.REACT_APP_BASE_NAME +`/preep-patients-report`
    );
  }

  const goTopatientStatusReport = () => {
    window.open(
      process.env.REACT_APP_BASE_NAME +`/patient-status`
    );
  }

  const goToPaediatricPatientsByProtocol = () => {
    window.open(
      process.env.REACT_APP_BASE_NAME +`/paediatric-patients-by-protocol`
    );
  }



  const handleChangeChoosenYear = (name, valueobj, value) => {
    setChosenValuesYear(valueobj);
    setCurrYearId(value);
  };

  const handleChangeChoosenMonth = (name, valueobj, value) => {
    setChosenValuesMonth(valueobj);
    setCurrMonthId(value);
  };

 /*  const handleFacilityChange = (event) => {
    setCurrFacilityId(event.target.value);
    // setLoading(true);
  }; */

/*   const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
 }; */

 const handleGenderChange = (event, newValue) => {
  let rowId = '';
  if(newValue == null){
  rowId = '';
  }else{
  rowId = newValue.id;
  }

  setCurrGenderTypeId(rowId);
};
  

  const handlesetAgeGroupChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrAgeGroupId(rowId);
 };


 
 const handleChangeToggle = (event, tmpToggleButtonValue) => {
  if (tmpToggleButtonValue) {
    setToggleButton(tmpToggleButtonValue);
  }
};
 
 const handleChangeTogglePaediatric = (event, tmpToggleButtonValuePaediatric) => {
  if (tmpToggleButtonValuePaediatric) {
    setToggleButtonPaediatric(tmpToggleButtonValuePaediatric);
  }
};

  const getCurrentMonthPatients = useQuery(
    ["patientdashboardcount"],
    () => api.getCurrentMonthPatients(currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId, currGenderTypeId, currAgeGroupId),
    {
      onSuccess: (data) => {
        console.log("Patient Count Data: ", data);
        setPatientCountDatat(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
    }
  );

  const getActivePatientsTrend = useQuery(
    ["patientdashboardactivetrend"],
    () => api.getActivePatientsTrend(currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId, currGenderTypeId, currAgeGroupId),
    {
      onSuccess: (data) => {
        // console.log('getActivePatientsTrend Data: ', data);
        // console.log('getActivePatientsTrend Data category: ', data.category);
        // console.log('getActivePatientsTrend Data series: ', data.series);
        // setActivePatientTrendData(data);

        // //Trend of Active Patients
        setActivePatientTrendData({
          chart: {
            type: "line",
            //height: 458,
            height: 515,
          },
          title: {
            text:  t(DispensingLanguage[lan][menukey]["Trend of Active Patients"]) +" - " +data.duration
          },
          yAxis: [
            {
              // Primary yAxis
              labels: {
                // format: '{value}Â°C',
                style: {
                  color: Highcharts.getOptions().colors[1],
                },
              },
              title: {
                text: t(
                  DispensingLanguage[lan][menukey]["Total & Adult Patients"]
                ),
                style: {
                  color: Highcharts.getOptions().colors[1],
                },
              },
            },
            {
              // Secondary yAxis
              title: {
                text: t(
                  DispensingLanguage[lan][menukey]["Paediatric Patients"]
                ),
                style: {
                  color: Highcharts.getOptions().colors[1],
                },
              },
              labels: {
                // format: '{value} mm',
                style: {
                  color: Highcharts.getOptions().colors[1],
                },
              },
              opposite: true,
            },
          ],
          tooltip: {
            shared: true,
          },
          xAxis: {
            // categories: ["Sep 2020","Oct 2020", "Nov 2020","Dec 2020","Jan 2021","Feb 2021", "Mar 2021","Apr 2021", "May 2021","Jun 2021","Jul 2021", "Aug 2021"],
            categories: data.category,
          },
          credits: {
            enabled: false,
          },
          series: data.series,
          // series: [
          //   {
          //     name: "Total Patients",
          //     data: [
          //       156271, 174392, 166229, 181092, 185301, 176558, 182117, 176445, 174321,
          //       179471, 180038, 179562,
          //     ],
          //     color: "#fe9929",
          //   },
          //   {
          //     name: "Adult Patients",
          //     data: [
          //       149924, 167377, 159609, 174093, 178277, 169897, 175317, 169905, 167997,
          //       172983, 173576, 173129,
          //     ],
          //     color: "#4f81bd",
          //   },
          //   {
          //     name: "Paediatric Patients",
          //     data: [
          //       6347, 7015, 6620, 6999, 7024, 6661, 6800, 6540, 6324, 6488, 6462, 6433,
          //     ],
          //     color: "#c0504d",
          //   },
          // ],
        });
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
    }
  );

  const getAdultPatientsByProtocol = useQuery(
    ["patientdashboardadultbyprotocol"],
    () =>
      api.getAdultPatientsByProtocol(currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId, currGenderTypeId, currAgeGroupId, toggleButtonValue),
    {
      onSuccess: (data) => {
        // console.log('getActivePatientsTrend Data: ', data);
        // console.log('getActivePatientsTrend Data category: ', data.category);
        // console.log('getActivePatientsTrend Data series: ', data.series);
        // setActivePatientTrendData(data);
        setAdultPatientsByProtocolData({
          chart: {
            type: "bar",
            borderColor: "#C3DDEC",
            //height: 320,
            height: 450,
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: data.category,
          },
          yAxis: {
            min: 0,
            max: 100,
            title: {
              text: "",
            },
          },
          legend: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          tooltip: {
            valueSuffix: " %",
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
                crop: true,
                formatter: function () {
                  return this.y + "%";
                },
              },
            },
          },
          series: [
            {
              name: t(DispensingLanguage[lan][menukey]["Patients"]),
              data: data.seriesdata, //[69.8, 18.2, 2.3, 2.1, 1.5, 1.5, 1, 0.8, 0.6, 0.6, 2.5],
            },
          ],
        });
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
    }
  );

  const getPaediatricPatientsByProtocol = useQuery(
    ["patientdashboardpaediatricbyprotocol"],
    () =>
      api.getPaediatricPatientsByProtocol(
        currYearId,
        currMonthId,
        currRegionId, 
        currZoneId, 
        currCommuneId, 
        currFacilityId,
        currGenderTypeId,
        currAgeGroupId,
        toggleButtonValuePaediatric
      ),
    {
      onSuccess: (data) => {
        // console.log('getActivePatientsTrend Data: ', data);
        // console.log('getActivePatientsTrend Data category: ', data.category);
        // console.log('getActivePatientsTrend Data series: ', data.series);
        // setActivePatientTrendData(data);
        setPaediatricPatientsByProtocolData({
          chart: {
            type: "bar",
            borderColor: "#C3DDEC",
            height: 320,
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: data.category,
          },
          yAxis: {
            min: 0,
            max: 100,
            title: {
              text: "",
            },
          },
          legend: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          tooltip: {
            valueSuffix: " %",
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
                crop: true,
                formatter: function () {
                  return this.y + "%";
                },
              },
            },
          },
          series: [
            {
              name: t(DispensingLanguage[lan][menukey]["Patients"]),
              data: data.seriesdata, //[69.8, 18.2, 2.3, 2.1, 1.5, 1.5, 1, 0.8, 0.6, 0.6, 2.5],
            },
          ],
        });
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
    }
  );



const { refetch: fetchDashboardStockStatusTableData} = useQuery(
  ["patientdashboardactivequeuepatientTable"],
  () => api.getDashboardActiveQueuePatientTableData(currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId, currGenderTypeId,currAgeGroupId, toggleButtonValueActiveQueue),
  {
    onSuccess: (data) => {

setColumnsStockStatusTable([
  {
    title: t(DispensingLanguage[lan][menukey]["Protocol Name"]),
    // width: 85,
    field: "RegimenName",
    headerSort: false,
  },
  {
    title:data.category['Key1'], field:"Key1", width:150, 
  hozAlign: "right",
  headerHozAlign: "right",
  headerSort: false,
},
  // {
  //   title:data.category['Key2'], field:"Key2", width:150, 
  // hozAlign: "right",
  // headerHozAlign: "right",
  // headerSort: false,
  // },
  {
    title:data.category['Key3'], field:"Key3", width:150, 
  hozAlign: "right",
  headerHozAlign: "right",
  headerSort: false,
  },
  {
    title:data.category['Key4'], field:"Key4", width:150, 
  hozAlign: "right",
  headerHozAlign: "right",
  headerSort: false,
  },
  {
    title:data.category['Key5'], field:"Key5", width:150, 
  hozAlign: "right",
  headerHozAlign: "right",
  headerSort: false,
  },
  {
    title:data.category['Key6'], field:"Key6", width:150, 
  hozAlign: "right",
  headerHozAlign: "right",
  headerSort: false,
  },
  {
    title:data.category['Key7'], field:"Key7", width:150, 
  hozAlign: "right",
  headerHozAlign: "right",
  headerSort: false,
  }
]);


  setStockStatusTableData(data.data);

    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0,//1000 * 60 * 60 * 24,
  }
);




  useEffect(() => {
    console.log("useEffect calling for refresh");

    if (currYearId > 0 && currMonthId > 0) {
      getCurrentMonthPatients.refetch();
      getActivePatientsTrend.refetch();
      getAdultPatientsByProtocol.refetch();
      getPaediatricPatientsByProtocol.refetch();
      fetchDashboardStockStatusTableData();
    }
  }, [currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId, currGenderTypeId, currAgeGroupId]);


  useEffect(() => {
      getAdultPatientsByProtocol.refetch();
      //getPaediatricPatientsByProtocol.refetch();
  }, [toggleButtonValue]);

  useEffect(() => {
    getPaediatricPatientsByProtocol.refetch();
  }, [toggleButtonValuePaediatric]);

  useEffect(() => {
    fetchDashboardStockStatusTableData();
  }, [toggleButtonValueActiveQueue]);

  
  const classes = useStyles();

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  /* const checkLogin = () => {  
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */
  if(RedirectLogin){
    setHasUserPermission(checkUserPermission(menukey));// To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }
  React.useEffect(() => {
    // checkLogin();
    // checkAccess();
  }, []);

  // const checkAccess = () => {
  //   // let auth = JSON.parse(sessionStorage.getItem("User_info"));
  //   let auth = Constants.USER_INFO;
  //   if (auth) {
  //     let menu = auth[0].menu;
  //     if (menu.length > 0) {
  //       var check = menu.filter((name) => name.title.includes("Dashboard"));
  //       if (check.length == 0) {
  //         props.history.push(menu[0].url);
  //       }
  //     } else {
  //       swal("Oops!", `You don't have permission to access any page`, "error");
  //       props.history.push("/login");
  //       sessionStorage.clear();
  //     }
  //   }
  // };

  

  // const checkLogin = () => {
  //   let token = sessionStorage.getItem("token");

  //   // let token = Constants.token;

  //   if (!token) {
  //     swal("Oops!", `token expired. Please login again`, "error");
  //     props.history.push("/login");
  //   }
  // };

  return (
    hasUserPermission && (
        <>
          <AfterLoginNavbar {...props} />

          <div
            className="section signup-top-padding"
            style={{
              backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
              backgroundSize: "cover",
              backgroundPosition: "top center",
              minHeight: "753px",
            }}
          >
            <div className="dashboard-pannel">
              <div className="d-flex justify-product mb-1">
                <div className="sw_page_heading">
                  <div className="sw_heading_title">
                    {t(DispensingLanguage[lan][menukey]["Patient Dashboard"])}
                  </div>
                </div>
              </div>

              {/* start of filter */}
              <Card className="sw_card sw_filter_card">
                <CardContent className="sw_filterCardContent">
                  <Grid container spacing={1}>
                    <Grid item xs={1} sm={1}>
                      <FormControl className={classes.fullWidth}>
                        <Autocomplete
                          autoHighlight
                          disableClearable
                          id="YearList"
                          options={YearList}
                          onChange={(event, valueobj) =>
                            handleChangeChoosenYear(
                              "YearList",
                              valueobj,
                              valueobj ? valueobj.id : ""
                            )
                          }
                          getOptionLabel={(option) => option?.name ?? ""}
                          isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                          value={chosenValuesYear}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={DispensingLanguage[lan][menukey]["YearName"]}
                              variant="standard"
                              id="YearList"
                              name="YearList"
                              fullWidth
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <FormControl className={classes.fullWidth}>
                        <Autocomplete
                          autoHighlight
                          disableClearable
                          id="MonthList"
                          options={MonthList}
                          onChange={(event, valueobj) =>
                            handleChangeChoosenMonth(
                              "MonthList",
                              valueobj,
                              valueobj ? valueobj.id : ""
                            )
                          }
                          getOptionLabel={(option) => option?.name ?? ""}
                          isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                          value={chosenValuesMonth}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={DispensingLanguage[lan][menukey]["Month"]}
                              variant="standard"
                              id="MonthList"
                              name="MonthList"
                              fullWidth
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>


                    
                    <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="RegionId"
                            options={Regionlist}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenRegion(
                                "RegionId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesRegion}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  DispensingLanguage[lan][menukey]["Department"]
                                }
                                variant="standard"
                                id="RegionId"
                                name="RegionId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="ZoneId"
                            options={ZoneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenZone(
                                "ZoneId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesZone}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["ZS"]}
                                variant="standard"
                                id="ZoneId"
                                name="ZoneId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="DistrictId"
                            options={CommuneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenDistrict(
                                "DistrictId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesDistrict}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Commune"]}
                                variant="standard"
                                id="DistrictId"
                                name="DistrictId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={3} sm={3}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="FacilityId"
                            options={FacilityList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenFacility(
                                "FacilityId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesFacility}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Facility"]}
                                variant="standard"
                                id="FacilityId"
                                name="FacilityId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    
                  
                    {/* <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}>
                       

                        <Autocomplete
                          autoHighlight
                          className="sw_chosen_filter"
                          id="FacilityList"
                          disableClearable
                          options={FacilityList}
                          onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                          getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                          defaultValue={FacilityList[FacilityList.findIndex(facilitylist => facilitylist.id == currFacilityId)]}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            // label={DispensingLanguage[lan][menukey]["All Facility"]}
                            variant="standard"
                            hiddenLabel
                          />
                          )}
                        />


                      </FormControl>
                    </Grid> */}

                    <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                        
                        <Autocomplete
                          autoHighlight
                          className="sw_chosen_filter"
                          id="GenderList"
                          disableClearable
                          options={GenderList}
                          onChange={(event, newValue) => handleGenderChange(event, newValue)}
                          getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={(GenderList.find(GenderList => GenderList.id == currGenderTypeId) ?? null)}
                          renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                          )}
                          
                          renderInput={(params) => (
                          <TextField
                          {...params}
                          variant="standard"
                          hiddenLabel
                          />
                          )}
                        />


                        </FormControl>
                      </Grid>


                    <Grid item xs={2} sm={2}>
                      <FormControl className={classes.fullWidth}>
                      
                        <Autocomplete
                          autoHighlight
                          className="sw_chosen_filter"
                          id="AgeGroup"
                          disableClearable
                          options={AgeGroup}
                          onChange={(event, newValue) => handlesetAgeGroupChange(event, newValue)}
                          getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={(AgeGroup.find(AgeGroup => AgeGroup.id == currAgeGroupId) ?? null)}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            hiddenLabel
                          />
                          )}
                        />


                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={6}></Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* end of filter */}

              {/* new row */}
              <div className="row">
                <div className="col-md-6 mb-4">
                  <Card className="sw_card">
                    <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey][
                          "Number of Active Patients"
                        ]
                      )}
                    />
                    <CardContent>
                      <div className="row">
                        <div className="col-md-5 mb-4">
                          <div className="stat-cell mb-2">

                           <a href="#" className="HyColor" onClick={goTopatientStatusReport}>
                              <Launch className="launch-icon" />
                            </a>

                            <i className="fa fa-user bg-icon"></i>
                            <span className="text-xlg" id="total-patients">
                              {PatientCountData.ActivePatient}
                            </span>
                            <br></br>
                            <span id="totalcase" className="text-bg">
                              {t(
                                DispensingLanguage[lan][menukey][
                                  "Total Active Patients"
                                ]
                              )}
                            </span>
                          </div>
                          <div className="stat-cell mb-2">

                           <a href="#" className="HyColor" onClick={goTopatientStatusReport}>
                              <Launch className="launch-icon" />
                            </a>

                            <i className="fa fa-user bg-icon"></i>
                            <span className="text-xlg" id="total-patients">
                              {PatientCountData.NewPatient}
                            </span>
                            <br></br>
                            <span id="totalcase" className="text-bg">
                              {t(
                                DispensingLanguage[lan][menukey][
                                  "New Patients This Month"
                                ]
                              )}
                            </span>
                          </div>


                          <div className="stat-cell">

                            <a href="#" className="HyColor" onClick={goToPreEPPatientsReport}>
                              <Launch className="launch-icon" />
                            </a>


                            <i className="fa fa-user bg-icon"></i>
                            
                            <span className="text-xlg" id="total-patients">
                              {PatientCountData.PreEPPatientCount}
                            </span>
                            <br></br>
                            <span id="totalcase" className="text-bg">
                              {t(
                                DispensingLanguage[lan][menukey][
                                  "PreEP Patients"
                                ]
                              )}
                            </span>

                              
                          </div>

                        </div>

                        <div className="col-md-7 mb-4">
                          {/* Adult Paediatric */}
                          <div className="sw_panel_body mb-5">
                             
                            <div className="progress bgcolor1">
                              <div
                                className="progress-bar bgcolor2"
                                style={{
                                  width:
                                    PatientCountData.AdultPatientPercentage + "%",
                                }}
                              ></div>
                            </div>
                            <div className="progress_text_box">
                              <div className="text_box textcolor1">
                                <span id="Adulttext_Patient">
                                  {t(DispensingLanguage[lan][menukey]["Adult"])}:{" "}
                                  {PatientCountData.AdultPatientPercentage}% (
                                  {PatientCountData.AdultPatient})
                                </span>
                              </div>
                              <div className="text_box textcolor2">
                                <span id="Paediatrictext_Patient">
                                  {t(
                                    DispensingLanguage[lan][menukey]["Paediatric"]
                                  )}
                                  : {PatientCountData.PaediatricPatientPercentage}%
                                  ({PatientCountData.PaediatricPatient})
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Female Male */}
                          <div className="sw_panel_body">
                            <div className="progress bgcolor3">
                              <div
                                className="progress-bar bgcolor4"
                                style={{
                                  width:
                                    PatientCountData.FemalePatientPercentage + "%",
                                }}
                              ></div>
                            </div>
                            <div className="progress_text_box">
                              <div className="text_box textcolor3">
                                <span id="Maletext_Patient">
                                  {t(DispensingLanguage[lan][menukey]["Female"])}:{" "}
                                  {PatientCountData.FemalePatientPercentage}% (
                                  {PatientCountData.FemalePatient})
                                </span>
                              </div>
                              <div className="text_box textcolor4">
                                <span id="Femaletext_Patient">
                                  {t(DispensingLanguage[lan][menukey]["Male"])}:{" "}
                                  {PatientCountData.MalePatientPercentage}% (
                                  {PatientCountData.MalePatient})
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>


                      <div className="row">
                        <div className="col-md-12">

                    <Card className="sw_card">
                    
                    <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey]["Trend of Active Patients"]
                      )}
                      action={
                      <a href="#" className="HyColor" onClick={goToTrendOfActivePatients}><Launch/></a>
                      }
                    />

                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">



                        {/* <a href="#" className="HyColor float-end" onClick={goToTrendOfActivePatients}><AddToHomeScreen/></a>
                        <br/><br/> */}

                          {/* {ActivePatientTrendData.length>0 && (<HighchartsReact
                            highcharts={Highcharts}
                            options={ActivePatientTrendData}
                          />)} */}
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={ActivePatientTrendData}
                          />
                        </div>
                      </div>

                      
                    </CardContent>
                  </Card>
                  </div></div>



                    </CardContent>
                  </Card>
                </div>
                <div className="col-md-6 mb-4">
                  <Card className="sw_card mb-3">
                    

                  {/*  <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey]["Adult Patients by Protocol"]
                      )}

                      action={
                        <a href="#" className="HyColor" onClick={goToAdultPatientsByProtocol}><Launch/></a>
                        
                      }
                      
                    /> */}

                    <CardHeader
                      title={t(DispensingLanguage[lan][menukey]["Adult Patients by Protocol"])}
                      action={
                        <div>
                          <ToggleButtonGroup
                            className="sw_ToggleButtonGroup"
                            color="primary"
                            value={toggleButtonValue}
                            exclusive
                            onChange={handleChangeToggle}
                          >
                            <ToggleButton value="1">{t(DispensingLanguage[lan][menukey]["Protocol"])}</ToggleButton>
                            <ToggleButton value="2">{t(DispensingLanguage[lan][menukey]["Regimen"])}</ToggleButton>
                          </ToggleButtonGroup>
                          <a href="#" className="HyColor" onClick={goToAdultPatientsByProtocol}>
                            <Launch />
                          </a>
                        </div>
                      }
                    />

                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={AdultPatientsByProtocolData}
                          />
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="sw_card">
                    


                    <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey]["Paediatric Patients by Protocol"]
                      )}
                      /* action={
                        <a href="#" className="HyColor" onClick={goToPaediatricPatientsByProtocol}><Launch/></a>
                      } */

                      action={
                        <div>
                          <ToggleButtonGroup
                            className="sw_ToggleButtonGroup"
                            color="primary"
                            value={toggleButtonValuePaediatric}
                            exclusive
                            onChange={handleChangeTogglePaediatric}
                          >
                            <ToggleButton value="1">{t(DispensingLanguage[lan][menukey]["Protocol"])}</ToggleButton>
                            <ToggleButton value="2">{t(DispensingLanguage[lan][menukey]["Regimen"])}</ToggleButton>
                          </ToggleButtonGroup>
                          <a href="#" className="HyColor" onClick={goToPaediatricPatientsByProtocol}><Launch/></a>
                        </div>
                      }

                    />


                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={PaediatricPatientsByProtocolData}
                          />
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
              
              <Card className="sw_card">
                    <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey]["Active Patient Queue by Protocol"]
                      )}
                    
                    />
                <CardContent>
                      <div className="row">
                        <div className="col-md-12 mb-12">
                      <div className="sw_relative">
                          {/* {isLoadingPatient && <LoadingSpinnerOpaque />} */}

                          <div className="uniqueName">
                              <ReactTabulator
                              height="400px"
                              layout={"fitColumns"}
                              columns={columnsStockStatusTable}
                              data={stockStatusTableData?stockStatusTableData:[]}
                            /> 

                          </div> 
                        </div>

                        </div> 
                        </div>

                  </CardContent>
                </Card>

              {/* <div className="row">
                <div className="col-md-12">
                  <Card className="sw_card">
                    <CardHeader title="Percentage of Patients at Risk" />
                    <CardContent>
                      <div className="sw_head_text">
                        <span>Total Patients: 180,104</span>
                        <span className="float-end">Patients At Risk: 8,142</span>
                      </div>
                      <div className="human_list_card mt-3">
                        <span className="badge per_badge">4.5 %</span>
                        <ul className="human_list float-end">
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_6.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                          <li>
                            <img
                              src={
                                process.env.PUBLIC_URL + "/images/human/human_0.png"
                              }
                              alt=""
                            />
                          </li>
                        </ul>
                      </div>
                      <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Formulation</TableCell>
                            <TableCell>Regimen</TableCell>
                            <TableCell align="right">Patient At Risk</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                      
                          <TableRow>
                            <TableCell component="th" scope="row">
                              1st Line Adult
                            </TableCell>
                            <TableCell>ABC/3TC/DTG-1</TableCell>
                            <TableCell align="right">2,643</TableCell>
                          </TableRow>
              
                          <TableRow>
                            <TableCell component="th" scope="row">
                              1st Line Adult
                            </TableCell>
                            <TableCell>ABC/3TC/EFV</TableCell>
                            <TableCell align="right">1,110</TableCell>
                          </TableRow>
              
                          <TableRow>
                            <TableCell component="th" scope="row">
                              2nd Line Adult
                            </TableCell>
                            <TableCell>AZT/3TC/TDF/ATV/r</TableCell>
                            <TableCell align="right">999</TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell component="th" scope="row">
                              1st Line Paediatric
                            </TableCell>
                            <TableCell>ABC/3TC/LPV/r</TableCell>
                            <TableCell align="right">914</TableCell>
                          </TableRow>
                  
                          <TableRow>
                            <TableCell component="th" scope="row">
                              2nd Line Adult
                            </TableCell>
                            <TableCell>AZT/3TC/TDF/LPV/r</TableCell>
                            <TableCell align="right">766</TableCell>
                          </TableRow>
                      
                          <TableRow>
                            <TableCell component="th" scope="row">
                              1st Line Paediatric
                            </TableCell>
                            <TableCell>ABC/3TC/LPV/r</TableCell>
                            <TableCell align="right">735</TableCell>
                          </TableRow>
                  
                          <TableRow>
                            <TableCell component="th" scope="row">
                              1st Line Adult
                            </TableCell>
                            <TableCell>TDF/3TC/ATV/r</TableCell>
                            <TableCell align="right">676</TableCell>
                          </TableRow>
                    
                          <TableRow>
                            <TableCell component="th" scope="row">
                              2nd Line Adult
                            </TableCell>
                            <TableCell>AZT/3TC/TDF/ATV/r</TableCell>
                            <TableCell align="right">299</TableCell>
                          </TableRow>
                    
                    
                          <TableRow>
                            <TableCell
                              style={{ "font-weight": "bold" }}
                              colSpan={2}
                            >
                              Total:
                            </TableCell>
                            <TableCell
                              style={{ "font-weight": "bold" }}
                              align="right"
                            >
                              8,142
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                </div>
              </div> */}
            </div>
          </div>
        </>)
  );
};

export default DashboardPage;
